import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex-col w-full px-2 justify-center items-center" }
const _hoisted_2 = {
  key: 0,
  class: "w-full md:px-2"
}
const _hoisted_3 = { class: "flex flex-col md:flex-row" }
const _hoisted_4 = { class: "w-full md:w-1/2 md:px-2" }
const _hoisted_5 = { class: "w-full md:w-1/2 md:px-2" }
const _hoisted_6 = { class: "flex w-full items-center justify-center" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "el-upload-list__item-actions" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex flex-col w-full" }
const _hoisted_13 = {
  key: 0,
  class: "barcode-scanner-container"
}
const _hoisted_14 = { class: "dialog-footer flex items-center" }
const _hoisted_15 = { class: "flex gap-2 ml-auto" }
const _hoisted_16 = { class: "flex justify-center items-center" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "dialog-footer flex items-center" }
const _hoisted_19 = { class: "flex gap-2 ml-auto" }
const _hoisted_20 = { class: "dialog-footer flex items-center" }
const _hoisted_21 = { class: "flex gap-2 ml-auto" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "flex flex-col md:flex-row" }
const _hoisted_24 = { class: "flex-1" }
const _hoisted_25 = { class: "flex-1" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = { class: "text-lg font-medium text-gray-900" }
const _hoisted_29 = { class: "flex justify-center items-center w-full h-full" }
const _hoisted_30 = {
  key: 0,
  class: "flex justify-end mt-4"
}
const _hoisted_31 = { class: "dialog-footer flex flex-col" }
const _hoisted_32 = {
  key: 0,
  class: "flex justify-end mb-2 min-h-6"
}
const _hoisted_33 = {
  key: 0,
  class: "text-red-500 text-sm"
}
const _hoisted_34 = { class: "flex items-center" }
const _hoisted_35 = { class: "flex gap-2 ml-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_OrganizationSelect = _resolveComponent("OrganizationSelect")!
  const _component_DepartmentSelect = _resolveComponent("DepartmentSelect")!
  const _component_CategorySelect = _resolveComponent("CategorySelect")!
  const _component_MaterialSelect = _resolveComponent("MaterialSelect")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_zoom_in = _resolveComponent("zoom-in")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_BarcodeScanner = _resolveComponent("BarcodeScanner")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.formVisibleModel,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formVisibleModel) = $event)),
      title: _ctx.form.add_update === 'add' ? '新規登録' : '詳細',
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          (_ctx.form.add_update === 'update' && _ctx.formShowDel)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "danger",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('delete', _ctx.form.inventory_id, _ctx.form.sk)))
              }, {
                default: _withCtx(() => _cache[42] || (_cache[42] = [
                  _createTextVNode(" 削除 ")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_button, {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.formVisibleModel = false))
            }, {
              default: _withCtx(() => _cache[43] || (_cache[43] = [
                _createTextVNode("キャンセル")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.form.add_update === 'add' ? '登録' : '更新'), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              (_ctx.form.add_update === 'add')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_el_form_item, {
                      label: "JANコード",
                      prop: "jancode",
                      "label-width": "100px",
                      error: _ctx.errorsModel?.jancode
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          "model-value": _ctx.form.jancode,
                          autocomplete: "off",
                          placeholder: "JANコード",
                          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:form', { ..._ctx.form, jancode: $event })))
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              style: {"background-color":"rgb(76, 175, 80)","color":"white","border":"none","height":"100%","margin":"0","padding":"0 8px","border-right":"1px solid #dcdfe6"},
                              onClick: _ctx.handleScanStart
                            }, {
                              default: _withCtx(() => _cache[40] || (_cache[40] = [
                                _createTextVNode(" スキャンを開始 ")
                              ])),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_button, {
                              style: {"background-color":"rgb(21, 96, 130)","color":"white","border":"none","height":"100%","margin":"0","padding":"0 8px","border-radius":"0 4px 4px 0"},
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('jancodeSearch', _ctx.form.jancode || '')))
                            }, {
                              default: _withCtx(() => _cache[41] || (_cache[41] = [
                                _createTextVNode(" 検索 ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model-value"])
                      ]),
                      _: 1
                    }, 8, ["error"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "組織",
                        prop: "organization_id",
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_OrganizationSelect, {
                            "model-value": _ctx.form.organization_id,
                            disabled: _ctx.form.add_update === 'update',
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:form', { ..._ctx.form, organization_id: $event }))),
                            onOrganizationNameChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:form', { ..._ctx.form, organization_name: $event }))),
                            placeholder: "組織を選択"
                          }, null, 8, ["model-value", "disabled"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "部門",
                        prop: "department_id",
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DepartmentSelect, {
                            "organization-id": _ctx.form.organization_id,
                            "model-value": _ctx.form.department_id,
                            disabled: _ctx.form.add_update === 'update',
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:form', { ..._ctx.form, department_id: $event }))),
                            onDepartmentNameChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:form', { ..._ctx.form, department_name: $event }))),
                            onOrganizationIdChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('organizationIdChange', $event))),
                            placeholder: "部門を選択"
                          }, null, 8, ["organization-id", "model-value", "disabled"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "カテゴリ",
                    prop: "category_id",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CategorySelect, {
                        "organization-id": _ctx.form.organization_id,
                        "model-value": _ctx.form.category_id,
                        disabled: _ctx.form.add_update === 'update',
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update:form', { ..._ctx.form, category_id: $event }))),
                        onCategoryNameChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:form', { ..._ctx.form, category_name: $event }))),
                        placeholder: "カテゴリを選択"
                      }, null, 8, ["organization-id", "model-value", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "アイテム名",
                    prop: "material_code",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MaterialSelect, {
                        "organization-id": _ctx.form.organization_id,
                        "category-id": _ctx.form.category_id,
                        "model-value": _ctx.form.material_code,
                        disabled: _ctx.form.add_update === 'update',
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:form', { ..._ctx.form, material_code: $event }))),
                        onMaterialNameChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update:form', { ..._ctx.form, material_name: $event }))),
                        "onUpdate:organizationId": _ctx.updateOrganizationId,
                        "onUpdate:categoryId": _ctx.updateCategoryId,
                        "onUpdate:expirationDay": _ctx.updateExpirationDate,
                        placeholder: "アイテム名を選択"
                      }, null, 8, ["organization-id", "category-id", "model-value", "disabled", "onUpdate:organizationId", "onUpdate:categoryId", "onUpdate:expirationDay"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "在庫数",
                    prop: "quantity",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        "model-value": _ctx.form.quantity,
                        min: 0,
                        max: 999999,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('update:form', { ..._ctx.form, quantity: $event })))
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_form_item, {
                    label: "保管日",
                    prop: "storage_date",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        "model-value": _ctx.form.storage_date,
                        type: "date",
                        placeholder: "保管日を選択",
                        "onUpdate:modelValue": _ctx.handleStorageDateChange
                      }, null, 8, ["model-value", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "有効期限",
                    prop: "expiration_date",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        "model-value": _ctx.form.expiration_date,
                        type: "date",
                        placeholder: "有効期限を選択",
                        "onUpdate:modelValue": _ctx.handleExpirationDateChange
                      }, null, 8, ["model-value", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "保管場所",
                    prop: "location",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        "model-value": _ctx.form.location,
                        autocomplete: "off",
                        placeholder: "保管場所を入力",
                        onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('update:form', { ..._ctx.form, location: $event })))
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "コメント",
                    prop: "comment",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        "model-value": _ctx.form.comment,
                        autocomplete: "off",
                        placeholder: "コメントを入力",
                        onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('update:form', { ..._ctx.form, comment: $event })))
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_upload, {
              action: "#",
              "list-type": "picture-card",
              "auto-upload": false,
              "on-change": _ctx.handleImageChange,
              multiple: "",
              "on-remove": _ctx.handleImageRemove,
              limit: 3,
              "on-exceed": _ctx.handleExceed,
              "file-list": _ctx.fileList,
              accept: ".jpg,.jpeg,.png,.webp,.gif"
            }, {
              file: _withCtx(({ file }) => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    class: "el-upload-list__item-thumbnail",
                    src: file.url,
                    alt: ""
                  }, null, 8, _hoisted_8),
                  _createElementVNode("span", _hoisted_9, [
                    _createElementVNode("span", {
                      class: "el-upload-list__item-preview",
                      onClick: ($event: any) => (_ctx.handlePictureCardPreview(file))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_zoom_in)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_10),
                    (!_ctx.disabled)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "el-upload-list__item-delete",
                          onClick: ($event: any) => (_ctx.$emit('imageRemove', file))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_11))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Plus)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["on-change", "on-remove", "on-exceed", "file-list"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.barcodeScannerState)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_BarcodeScanner, {
                  ref: "barcodeScannerRef",
                  onCodeScanned: _ctx.handleScanSuccess,
                  onScanStopped: _cache[14] || (_cache[14] = ($event: any) => (_ctx.barcodeScannerState = false))
                }, null, 8, ["onCodeScanned"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.imagePreviewVisibleModel,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.imagePreviewVisibleModel) = $event)),
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("img", {
            "w-full": "",
            src: _ctx.dialogImageUrl,
            alt: "Preview Image"
          }, null, 8, _hoisted_17)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      modelValue: _ctx.alarmVisibleModel,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.alarmVisibleModel) = $event)),
      title: "アラート設定",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          (_ctx.alarmForm.add_update === 'update')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "danger",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$emit('deleteReminder')))
              }, {
                default: _withCtx(() => _cache[50] || (_cache[50] = [
                  _createTextVNode(" 削除 ")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_button, {
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.alarmVisibleModel = false))
            }, {
              default: _withCtx(() => _cache[51] || (_cache[51] = [
                _createTextVNode("キャンセル")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleAlarmSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.alarmForm.add_update === 'add' ? '登録' : '更新'), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.alarmForm,
          rules: _ctx.alarmRules,
          ref: "alarmFormRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "責任者",
              prop: "responsible_person"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  "organization-id": _ctx.alarmForm.organization_id,
                  "model-value": _ctx.alarmForm.responsible_person,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('update:alarmForm', { ..._ctx.alarmForm, responsible_person: $event }))),
                  placeholder: "責任者を選択"
                }, null, 8, ["organization-id", "model-value"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "アラート設定",
              prop: "alarm_setting"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  "model-value": _ctx.alarmForm.alarm_setting,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('update:alarmForm', { ..._ctx.alarmForm, alarm_setting: $event })))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, { label: "1日以内" }, {
                      default: _withCtx(() => _cache[44] || (_cache[44] = [
                        _createTextVNode("1日以内")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, { label: "1日前" }, {
                      default: _withCtx(() => _cache[45] || (_cache[45] = [
                        _createTextVNode("1日前")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, { label: "7日前" }, {
                      default: _withCtx(() => _cache[46] || (_cache[46] = [
                        _createTextVNode("7日前")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, { label: "15日前" }, {
                      default: _withCtx(() => _cache[47] || (_cache[47] = [
                        _createTextVNode("15日前")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, { label: "30日前" }, {
                      default: _withCtx(() => _cache[48] || (_cache[48] = [
                        _createTextVNode("30日前")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, { label: "在庫数" }, {
                      default: _withCtx(() => _cache[49] || (_cache[49] = [
                        _createTextVNode("在庫数")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model-value"])
              ]),
              _: 1
            }),
            (_ctx.alarmForm.alarm_setting.includes('在庫数'))
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "在庫数",
                  prop: "quantity"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      "model-value": _ctx.alarmForm.quantity,
                      min: 0,
                      max: 999999,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('update:alarmForm', { ..._ctx.alarmForm, quantity: $event })))
                    }, null, 8, ["model-value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "有効" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  "model-value": _ctx.alarmForm.is_actived,
                  "active-value": "1",
                  "inactive-value": "0",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('update:alarmForm', { ..._ctx.alarmForm, is_actived: $event })))
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      modelValue: _ctx.constantVisibleModel,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.constantVisibleModel) = $event)),
      title: _ctx.constantSettingLevel === 'organization' ? '組織定数設定' : '部門定数設定',
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_button, {
              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.constantVisibleModel = false))
            }, {
              default: _withCtx(() => _cache[52] || (_cache[52] = [
                _createTextVNode("キャンセル")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleConstantSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.constantForm.add_update === 'add' ? '登録' : '更新'), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.constantForm,
          rules: _ctx.constantRules,
          ref: "constantFormRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "定数" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  "model-value": _ctx.constantForm.constant_value,
                  min: 0,
                  max: 999999,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.$emit('update:constantForm', { ..._ctx.constantForm, constant_value: $event })))
                }, null, 8, ["model-value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog transfer-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.transferInventoryVisibleModel,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.transferInventoryVisibleModel) = $event)),
      title: _ctx.transferInventoryStep !== 2 ? '払い出し' : '払い出し（選択）',
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          (_ctx.transferInventoryStep === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                (_ctx.step2Error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.step2Error), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_el_button, {
                onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.transferInventoryVisibleModel = false))
              }, {
                default: _withCtx(() => _cache[55] || (_cache[55] = [
                  _createTextVNode("キャンセル")
                ])),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleTransferInventorySubmit,
                loading: _ctx.targetInventoryListLoading
              }, {
                default: _withCtx(() => _cache[56] || (_cache[56] = [
                  _createTextVNode(" 払い出し ")
                ])),
                _: 1
              }, 8, ["onClick", "loading"])
            ])
          ])
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.transferInventoryStep !== 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_el_form, {
                model: _ctx.transferInventoryForm,
                rules: _ctx.transferFormRules,
                ref: "transferInventoryFormRef",
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "アイテム名",
                    "label-width": "120px"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.transferInventoryForm.material_name), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_el_form_item, {
                        label: "部門（元）",
                        "label-width": "120px"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.transferInventoryForm.department_name), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_el_form_item, {
                        prop: "dest_department_id",
                        "label-width": "120px"
                      }, {
                        label: _withCtx(() => _cache[53] || (_cache[53] = [
                          _createElementVNode("div", { class: "flex items-center" }, [
                            _createElementVNode("span", { class: "material-symbols-outlined text-lg text-gray-500 mr-2" }, " arrow_forward "),
                            _createElementVNode("span", null, "部門（先）")
                          ], -1)
                        ])),
                        default: _withCtx(() => [
                          _createVNode(_component_DepartmentSelect, {
                            "organization-id": _ctx.transferInventoryForm.organization_id,
                            "model-value": _ctx.transferInventoryForm.dest_department_id,
                            "is-exclude-target-department": true,
                            "target-department-id": _ctx.transferInventoryForm.department_id,
                            "onUpdate:modelValue": _ctx.handleDepartmentChange,
                            onDepartmentNameChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$emit('update:transferInventoryForm', { ..._ctx.transferInventoryForm, dest_department_name: $event }))),
                            placeholder: "部門を選択"
                          }, null, 8, ["organization-id", "model-value", "target-department-id", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_component_el_form_item, {
                    label: "個数",
                    prop: "transfer_quantity"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        "model-value": _ctx.transferInventoryForm.transfer_quantity,
                        min: 0,
                        max: _ctx.transferInventoryForm.quantity,
                        "onUpdate:modelValue": _ctx.handleTransferQuantityChange
                      }, null, 8, ["model-value", "max", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "操作者",
                    prop: "transfer_operator",
                    "label-width": "120"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        maxlength: "10",
                        width: "120px",
                        "model-value": _ctx.transferInventoryForm.transfer_operator,
                        placeholder: "操作者を入力",
                        autocomplete: "off",
                        onInput: _cache[30] || (_cache[30] = ($event: any) => (_ctx.$emit('update:transferInventoryForm', { ..._ctx.transferInventoryForm, transfer_operator: $event })))
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "メモ" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        "model-value": _ctx.transferInventoryForm.transfer_memo,
                        autocomplete: "off",
                        placeholder: "メモを入力",
                        autosize: { minRows: 2, maxRows: 5 },
                        onInput: _cache[31] || (_cache[31] = ($event: any) => (_ctx.$emit('update:transferInventoryForm', { ..._ctx.transferInventoryForm, transfer_memo: $event })))
                      }, null, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.transferInventoryStep === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("h3", _hoisted_28, _toDisplayString(_ctx.transferInventoryForm.material_name) + " （保管日：" + _toDisplayString(_ctx.formatDate(_ctx.transferInventoryForm.storage_date)) + "，有効期限：" + _toDisplayString(_ctx.formatDate(_ctx.transferInventoryForm.expiration_date)) + "）", 1)
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                data: _ctx.sortedPaginatedTargetInventory,
                style: {"width":"100%"},
                border: "",
                "highlight-current-row": "",
                "header-row-class-name": "table-header-row"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "",
                    width: "50",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_el_radio, {
                          "model-value": _ctx.selectedTargetInventoryId,
                          label: row.inventory_id,
                          "onUpdate:modelValue": ($event: any) => (_ctx.handleTargetInventorySelect(row)),
                          class: "radio-center"
                        }, {
                          default: _withCtx(() => _cache[54] || (_cache[54] = [
                            _createElementVNode("span", null, null, -1)
                          ])),
                          _: 2
                        }, 1032, ["model-value", "label", "onUpdate:modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "storage_date",
                    width: "120",
                    align: "left"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handleTargetInventorySort('storage_date')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getTargetInventorySortLabel('storage_date')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.targetInventorySortField === 'storage_date' }])
                            }, _toDisplayString(_ctx.getTargetInventorySortIcon('storage_date')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(row.storage_date)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "expiration_date",
                    width: "120",
                    align: "left"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.handleTargetInventorySort('expiration_date')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getTargetInventorySortLabel('expiration_date')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.targetInventorySortField === 'expiration_date' }])
                            }, _toDisplayString(_ctx.getTargetInventorySortIcon('expiration_date')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(row.expiration_date)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "quantity",
                    width: "100",
                    align: "left"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.handleTargetInventorySort('quantity')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getTargetInventorySortLabel('quantity')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.targetInventorySortField === 'quantity' }])
                            }, _toDisplayString(_ctx.getTargetInventorySortIcon('quantity')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "location",
                    "min-width": "120"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.handleTargetInventorySort('location')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getTargetInventorySortLabel('location')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.targetInventorySortField === 'location' }])
                            }, _toDisplayString(_ctx.getTargetInventorySortIcon('location')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "comment",
                    "min-width": "120"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.handleTargetInventorySort('comment')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getTargetInventorySortLabel('comment')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.targetInventorySortField === 'comment' }])
                            }, _toDisplayString(_ctx.getTargetInventorySortIcon('comment')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, _ctx.targetInventoryListLoading]
              ]),
              (_ctx.targetInventoryTotal > _ctx.targetInventoryPageSize)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createVNode(_component_el_pagination, {
                      "current-page": _ctx.targetInventoryCurrentPage,
                      "onUpdate:currentPage": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.targetInventoryCurrentPage) = $event)),
                      "page-size": _ctx.targetInventoryPageSize,
                      total: _ctx.targetInventoryTotal,
                      layout: "prev, pager, next",
                      onCurrentChange: _ctx.handleTargetInventoryPageChange
                    }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}